import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const PartyAutoSuggest = ({
  party,
  selectedPartyId,
  selectedPartyName,
  onSelect,
  disabled = false,
}) => {
  const [searchTerm, setSearchTerm] = useState(selectedPartyName || "");
  const [filteredParties, setFilteredParties] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (selectedPartyId && party?.length > 0) {
      const selected = party.find((p) => p._id === selectedPartyId);
      if (selected) {
        setSearchTerm(selected.name || "");
        return;
      }
    }
    if (selectedPartyName) {
      setSearchTerm(selectedPartyName);
    }
  }, [selectedPartyId, selectedPartyName, party]);

  //  Filter list based on search term
  // useEffect(() => {
  //   if (!party) return;
  //   const filtered = searchTerm
  //     ? party.filter((p) =>
  //         p.name.toLowerCase().includes(searchTerm.toLowerCase()),
  //       )
  //     : party;
  //   setFilteredParties(filtered);
  // }, [searchTerm, party]);

  // Filter only Vendor and Both parties, then apply search
  useEffect(() => {
    if (!party) {
      setFilteredParties([]);
      return;
    }

    const allowedParties = party.filter((p) =>
      ["vendor", "both"].includes(p.partyType?.toLowerCase()),
    );

    const filtered = searchTerm
      ? allowedParties.filter((p) =>
          p.name?.toLowerCase().includes(searchTerm.toLowerCase()),
        )
      : allowedParties;

    setFilteredParties(filtered);
  }, [searchTerm, party]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };

  const handleSelect = (p) => {
    setSearchTerm(p.name);
    setIsOpen(false);
    onSelect(p);
  };

  const toggleDropdown = () => {
    if (disabled) return;
    setIsOpen((prev) => !prev);
    if (!isOpen) setFilteredParties(party);
  };

  return (
    <div className="position-relative" ref={wrapperRef}>
      <div className="input-group">
        <input
          type="text"
          className="form-control"
          placeholder="Search or Select Vendor"
          onChange={handleInputChange}
          onFocus={() => !disabled && setIsOpen(true)}
          value={searchTerm}
          disabled={disabled}
        />
        {/* Chevron Button */}
        <button
          type="button"
          className="btn border d-flex align-items-center justify-content-center"
          onClick={toggleDropdown}
          disabled={disabled}
          style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        >
          {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
        </button>
      </div>

      {/* Dropdown list */}
      {isOpen && filteredParties?.length > 0 && (
        <ul
          className="list-group position-absolute w-100"
          style={{
            zIndex: 1000,
            maxHeight: "200px",
            overflowY: "auto",
          }}
        >
          {filteredParties.map((p) => (
            <li
              key={p._id}
              className="list-group-item list-group-item-action"
              onClick={() => handleSelect(p)}
              style={{ cursor: "pointer" }}
            >
              {p.name}
            </li>
          ))}
        </ul>
      )}

      {/* No results */}
      {isOpen && filteredParties?.length === 0 && (
        <div
          className="list-group position-absolute w-100"
          style={{ zIndex: 1000 }}
        >
          <div className="list-group-item">No parties found</div>
        </div>
      )}
    </div>
  );
};

export default PartyAutoSuggest;
